import { render, staticRenderFns } from "./BookDisplayPanel.vue?vue&type=template&id=77bc1378&scoped=true&"
import script from "./BookDisplayPanel.vue?vue&type=script&lang=js&"
export * from "./BookDisplayPanel.vue?vue&type=script&lang=js&"
import style0 from "./BookDisplayPanel.vue?vue&type=style&index=0&id=77bc1378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc1378",
  null
  
)

export default component.exports